import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

const validateBody = body => body.actionType && body.actionValue

/**
 * Crea para un lead, un registro en el historial, guardando que se contactó al lead por Whatsapp
 * @param {string} leadId id del lead
 * @returns {Promise} Devuelve la respuesta de la creación del registro en Histories
 */
export function createHistoryLeadContactViaWhatsapp(leadId) {
    const actionValue = 'Whatsapp.'
    return createHistoryLeadContact(leadId, actionValue)
}

/**
 * Crea para un lead, un registro en el historial, guardando que se contactó al lead por el actionValue
 * @param {string} leadId id del lead
 * @param {string} actionValue valor de la acción a gardar en el historial
 * @returns {Promise} Devuelve la respuesta de la creación del registro en Histories
 */
export function createHistoryLeadContact(leadId, actionValue) {
    const historyBody = {
        actionType: 'contactLead',
        actionValue
    }
    return createHistoryLead(leadId, historyBody)
}

/**
 * Lead: Botón COTIZAR, crear un nuevo registro en el historial, cuando se genera (guarda), la cotización.
 * @param {string} leadId id del lead
 * @param {string} quotationId id (nro) de la nueva cotización
 * @returns {Promise} Devuelve la respuesta de la creación del registro en Histories
 */
export async function createHistoryLeadQuotation(leadId, quotationId) {
    const body = {
        actionType: 'quotationLead',
        actionValue: `cotización N° ${quotationId}`
    }
    return createHistoryLead(leadId, body)
}

/**
 * Crea para un lead, un registro en el historial, guardando que se accedió al Catálogo
 * @param {string} leadId id del lead
 * @returns {Promise} Devuelve la respuesta de la creación del registro en Histories
 */
export function createHistoryLeadAccessCatalog(leadId) {
    const historyBody = {
        actionType: 'accessCatalog',
        actionValue: 'Catálogo',
    }
    return createHistoryLead(leadId, historyBody)
}

/**
 * Crea para un lead, un registro en el historial, guardando que se solicito un peritaje
 * @param {string} leadId id del lead
 * @returns {Promise} Devuelve la respuesta de la creación del registro en Histories
 */
export function createHistoryLeadForRequest(leadId, body) {
    return axios.post(`${LEADS_ENDPOINT}/history/${leadId}`, body)
}

/**
 * Crea para un lead, un registro en el historial
 * @param {string} leadId id del lead
 * @param {Object} body datos del historial por crear con las propiedades: 'actionType', 'actionValue': definidas
 * @returns {Promise} Devuelve la respuesta de la creación del registro en Histories
 */
export function createHistoryLead(leadId, body) {
    if (!validateBody(body)) throw new Error('invalid body')

    return axios.post(`${LEADS_ENDPOINT}/history/${leadId}`, body)
}
